import { createSlice } from "@reduxjs/toolkit";
// import patientList from "../../../rtk-apis/patients/patientList";

import latestModality from "@custom/rtk-apis/appointment/latestModality";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const latestModalitySlice = createSlice({
  name: "latestModalitySlice",
  initialState,
  reducers: {
    closeLatestModal (state:any) { state.status = "",state.result=null; }
  },
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(latestModality.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(latestModality.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(latestModality.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default latestModalitySlice.reducer;
export const { closeLatestModal } = latestModalitySlice.actions;
